// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"460":"494bfeb4","679":"088c6361","728":"7a0eb98c"}[chunkId] + ".chunk.css";
};